import React from "react";
import { RouteComponentProps } from "react-router";
import TicketsSearch from "@tickets/TicketSearch/TicketsSearch";

type Props = RouteComponentProps<any> & {};

function TicketsSearchPage(props: Props) {
  return <TicketsSearch {...props} />;
}

export default TicketsSearchPage;
